import React from "react";
import { Button, ButtonVariant, Text } from "@merge-api/merge-javascript-shared";

import { LOGIN_PATH } from "../../../../router/RouterUtils";
import AuthCard from "./AuthCard";
import AuthPageWrapper from "./AuthPageWrapper";

/**
 * Composed from AuthPageWrapper and AuthCard rather than AuthLayout, which
 * redirects when an auth token is present. Both actions navigate rather than
 * re-render, since the tree that threw cannot be trusted to mount again.
 */
const AuthErrorFallback = () => (
  <AuthPageWrapper>
    <AuthCard className="p-6 flex flex-col gap-6">
      <div className="flex flex-col gap-2">
        <Text variant="h3">Something went wrong</Text>
        <Text variant="md" className="text-gray-60">
          This page did not finish loading. Reloading usually fixes it, and your account is
          unaffected.
        </Text>
      </div>
      <div className="flex flex-col gap-3">
        <Button fullWidth onClick={() => window.location.reload()}>
          Reload page
        </Button>
        <Button
          variant={ButtonVariant.TextBlue}
          fullWidth
          onClick={() => {
            window.location.href = LOGIN_PATH;
          }}
        >
          Back to login
        </Button>
      </div>
    </AuthCard>
  </AuthPageWrapper>
);

export default AuthErrorFallback;
